import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Scribble.svg?component
var Scribble_exports = /* @__PURE__ */ __exportAll({
	default: () => Scribble_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M3 15c1.895 3 3.79 4 6.632 4s6.631-3 6.631-7-2.842-7-5.684-7-4.737 1.5-4.737 4 1.895 5 5.684 5S19.492 11.547 21 9"
	}, null, -1)])]);
}
var Scribble_default = { render: render$1 };
//#endregion
export { Scribble_exports, Scribble_default as default, render$1 as render };

//# sourceMappingURL=Scribble.svg_component.js.map